import React, { useState } from 'react';
import { Calendar, Clock, Users, Building, Mail, User, Phone } from 'lucide-react';

const DemoForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    phone: '',
    teamSize: '',
    date: '',
    time: ''
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission
    console.log('Form submitted:', formData);
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <div id="demo-form" className="relative py-20 bg-black/50 backdrop-blur-xl">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold mb-4 bg-gradient-to-r from-cyan-400 via-purple-400 to-indigo-400 bg-clip-text text-transparent">
            Book Your Demo
          </h2>
          <p className="text-xl text-gray-400">
            See how our platform can transform your data analysis workflow
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* Name Field */}
            <div className="relative">
              <label className="block text-sm font-medium text-gray-400 mb-2">
                Full Name
              </label>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <User className="h-5 w-5 text-gray-500" />
                </div>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  className="w-full bg-gray-900/50 backdrop-blur-sm border border-gray-800 rounded-lg pl-10 px-4 py-2.5 text-white focus:ring-2 focus:ring-cyan-400 focus:border-transparent"
                  required
                  placeholder="John Doe"
                />
              </div>
            </div>

            {/* Email Field */}
            <div className="relative">
              <label className="block text-sm font-medium text-gray-400 mb-2">
                Work Email
              </label>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <Mail className="h-5 w-5 text-gray-500" />
                </div>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  className="w-full bg-gray-900/50 backdrop-blur-sm border border-gray-800 rounded-lg pl-10 px-4 py-2.5 text-white focus:ring-2 focus:ring-cyan-400 focus:border-transparent"
                  required
                  placeholder="john@company.com"
                />
              </div>
            </div>

            {/* Company Field */}
            <div className="relative">
              <label className="block text-sm font-medium text-gray-400 mb-2">
                Company Name
              </label>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <Building className="h-5 w-5 text-gray-500" />
                </div>
                <input
                  type="text"
                  name="company"
                  value={formData.company}
                  onChange={handleChange}
                  className="w-full bg-gray-900/50 backdrop-blur-sm border border-gray-800 rounded-lg pl-10 px-4 py-2.5 text-white focus:ring-2 focus:ring-cyan-400 focus:border-transparent"
                  required
                  placeholder="Company Inc."
                />
              </div>
            </div>

            {/* Phone Field */}
            <div className="relative">
              <label className="block text-sm font-medium text-gray-400 mb-2">
                Phone Number
              </label>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <Phone className="h-5 w-5 text-gray-500" />
                </div>
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  className="w-full bg-gray-900/50 backdrop-blur-sm border border-gray-800 rounded-lg pl-10 px-4 py-2.5 text-white focus:ring-2 focus:ring-cyan-400 focus:border-transparent"
                  placeholder="+1 (555) 000-0000"
                />
              </div>
            </div>

            {/* Team Size Field */}
            <div className="relative">
              <label className="block text-sm font-medium text-gray-400 mb-2">
                Team Size
              </label>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <Users className="h-5 w-5 text-gray-500" />
                </div>
                <select
                  name="teamSize"
                  value={formData.teamSize}
                  onChange={handleChange}
                  className="w-full bg-gray-900/50 backdrop-blur-sm border border-gray-800 rounded-lg pl-10 px-4 py-2.5 text-white focus:ring-2 focus:ring-cyan-400 focus:border-transparent appearance-none"
                  required
                >
                  <option value="">Select team size</option>
                  <option value="1-10">1-10 employees</option>
                  <option value="11-50">11-50 employees</option>
                  <option value="51-200">51-200 employees</option>
                  <option value="201-500">201-500 employees</option>
                  <option value="500+">500+ employees</option>
                </select>
              </div>
            </div>

            {/* Preferred Date */}
            <div className="relative">
              <label className="block text-sm font-medium text-gray-400 mb-2">
                Preferred Date
              </label>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <Calendar className="h-5 w-5 text-gray-500" />
                </div>
                <input
                  type="date"
                  name="date"
                  value={formData.date}
                  onChange={handleChange}
                  className="w-full bg-gray-900/50 backdrop-blur-sm border border-gray-800 rounded-lg pl-10 px-4 py-2.5 text-white focus:ring-2 focus:ring-cyan-400 focus:border-transparent"
                  required
                />
              </div>
            </div>
          </div>

          {/* Additional Information */}
          <div>
            <label className="block text-sm font-medium text-gray-400 mb-2">
              Additional Information
            </label>
            <textarea
              name="message"
              rows="4"
              className="w-full bg-gray-900/50 backdrop-blur-sm border border-gray-800 rounded-lg px-4 py-2.5 text-white focus:ring-2 focus:ring-cyan-400 focus:border-transparent"
              placeholder="Tell us about your specific needs or questions..."
            />
          </div>

          {/* Submit Button */}
          <div className="text-center">
            <button
              type="submit"
              className="bg-cyan-500 hover:bg-violet-500 text-white px-8 py-3 rounded-lg font-medium transition-colors inline-flex items-center justify-center"
            >
              Schedule Demo
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default DemoForm;